import { Schema, SchemaSettings } from '@orbit/data'
import { KC } from '@/http/utils'

enum ModelTypes {
  Unit = 'unit',
}

enum ModelTypeNames {
  Unit = 'unit',
}

export interface UnitAttributes {
  unitId: string
  unitDesc: string
  siteId: string
  enabled: boolean
  patients?: object[]
  withPackages?: boolean
}

export interface UnitsScheme {
  id: string
  attributes: UnitAttributes
}

const schemaDefinition: SchemaSettings = {
  models: {
    [ModelTypeNames.Unit]: {
      keys: {
        remoteId: {},
      },
      attributes: {
        unitId: { type: 'string' },
        unitDesc: { type: 'string' },
        enabled: { type: 'boolean' },
        siteId: { type: 'string' },
        patients: { type: 'array' },
        withPackages: { type: 'boolean' },
      },
    },
  },
}

export async function getUnitsQuery() {
  // not implemented
}

export async function patchUnitQuery(payload) {
  const schema = new Schema(schemaDefinition)
  const remote = await KC.getJsonApiRemoteResource(schema)
  return remote.push(q => {
    console.log('Before calling update record for unit')
    return q.updateRecord({
      id: payload.id,
      type: ModelTypeNames.Unit,
      attributes: payload.attributes,
    })
  })
}
